// extracted by mini-css-extract-plugin
module.exports = {"ToggleButton":"style_ToggleButton__1vJ0R"};